<template>
  <hot-sales-detail :is-edit='false'>
  </hot-sales-detail>
</template>

<script>
import HotSalesDetail from '../components/HotSalesDetail'
export default {
  name: 'CreateHotSales',
  components: {
    HotSalesDetail
  }
}
</script>

